import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Create,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
  TextInput,
  DateInput,
  required,
  minValue,
} from "react-admin";
import type { CreateProps } from "react-admin";
import { redirectToProjectModuleDashboard } from "@/containers/projects/redirect-to-project-module-dashboard";
import { useRouteId } from "@/utils/route-utility";

export const ProjectInayatCreate = (props: CreateProps) => {
  const [searchParams] = useSearchParams();
  const routeProjectId = useRouteId();
  const initialProjectId = useMemo(
    () => routeProjectId ?? searchParams.get("projectId") ?? undefined,
    [searchParams, routeProjectId]
  );
  const queryProjectId = searchParams.get("projectId");
  const redirectTo = useMemo(
    () => redirectToProjectModuleDashboard({ routeProjectId, queryProjectId, fallback: "list" }),
    [routeProjectId, queryProjectId]
  );

  return (
    <Create
      {...props}
      redirect={redirectTo}
      transform={(data: Record<string, unknown>) => ({
        projectId: routeProjectId ?? data.projectId,
        amount: Number(data.amount),
        receivedDate: data.receivedDate,
        reference:
          typeof data.reference === "string" ? data.reference.trim() || undefined : data.reference,
        remarks: typeof data.remarks === "string" ? data.remarks.trim() || undefined : data.remarks,
      })}
    >
      <SimpleForm defaultValues={{ projectId: initialProjectId }}>
        {!routeProjectId && (
          <ReferenceInput source="projectId" reference="projects" perPage={100}>
            <AutocompleteInput optionText="name" label="Project" validate={required()} />
          </ReferenceInput>
        )}
        <NumberInput source="amount" validate={[required(), minValue(1)]} />
        <DateInput source="receivedDate" validate={required()} />
        <TextInput source="reference" fullWidth />
        <TextInput source="remarks" multiline fullWidth />
      </SimpleForm>
    </Create>
  );
};
